import { subscribe } from "../emitter-subscriber/subscribe";
import { rumSendPageView } from "../rum/rum-event";
const create = () => {
    const pageViewSubscription = () => {
        subscribe("AAT_PAGE_VIEW", (pageId) => {
            // console.log("Page View Event->", pageId);
            // debugger;
            rumSendPageView(pageId);
            // const event = {
            //   pageView: payload.record,
            // };
            // rumSendPageView(eventDetails(event, eventTypes.pageView));
        });
        // subscribe("AAT_PAGE_VIEW", (payload: string) => {
        // })
        // subscribe("AAT_PAGE_VIEW", payload: string) => {
        //   console.log("Page View Event->", payload);
        //   // const event = {
        //   //   pageView: payload,
        //   // };
        //   // rumSendPageView(eventDetails(event, eventTypes.pageView));
        //   // const eventDetails = this.createEventDetails(event, eventTypes.pageView);
        //   //             this.addEvent(eventDetails);
        //   //             if (this.sendRUMData) {
        //   //                 const [metaError, metaResult] = handleError(() => cwr('recordPageView', {
        //   //                     pageId: j
        //   //                 }));
        //   //                 if (metaError) {
        //   //                     console.warn('[Tracking] Error executing CWR event:', metaError)
        //   //                     return;
        //   //                 }
        //   //             }
        // });
    };
    return { pageViewSubscription };
};
export const { pageViewSubscription } = create();
function payload(payload) {
    throw new Error("Function not implemented.");
}



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/events/page-view.js
// module id = ./node_modules/@celine/passive-tracking/dist/events/page-view.js
// module chunks = 0